import React, { useCallback, useEffect, useState } from "react";

import { addCourse, getAllAdminModules, getMethods } from "services";

import { useCancelAsyncOnUnmount, useNavigate } from "utils";

import { AdminHead, ErrorBoundary, MainPage, Tabs, Message as message } from "components";

import { CourseDetailsForm } from "pages/admin/content/components/CourseDetailsForm";

export const CourseAdd = ({ defaultTab }) => {
  const [loading, setLoading] = useState(false);
  const [methods, setMethods] = useState([]);
  const [modules, setModules] = useState([]);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const handleCourseAdd = (v) => {
    setLoading(true);

    addCourse({
      ...v,
      modules: [],
    })
      .then((res) => {
        navigate(`/course/update/${res.id}/`);
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loadModules = useCallback(() => {
    getAllAdminModules({
      signal,
    }).then((res) => {
      setModules(res);
    });
  }, [signal]);

  const loadMethods = useCallback(() => {
    getMethods({
      signal,
    }).then((res) => {
      setMethods(res);
    });
  }, [signal]);

  useEffect(() => {
    loadMethods();
    loadModules();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <ErrorBoundary>
        <AdminHead course link={"/content/courses"} title={"Add a new course"} tooltipText={"Back to courses"} />
      </ErrorBoundary>
      <Tabs
        defaultActiveKey={defaultTab}
        size="small"
        items={[
          {
            label: "Course Details",
            key: "course",
            children: (
              <ErrorBoundary>
                <CourseDetailsForm complete={handleCourseAdd} loading={loading} methods={methods} modules={modules} setLoading={setLoading} />
              </ErrorBoundary>
            ),
          },
          {
            label: "Course Chapters",
            key: "chapters",
            disabled: true,
          },
        ]}
      />
    </MainPage>
  );
};
